import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { UserState } from "./types";
import { User } from "@/models/user_schema";

const state: UserState = {
  user: {} as User,
  error: false
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
